module.exports = __webpack_public_path__ + "static/media/new-login-bg.7c273178.jpg";